import { render } from "./section-three.vue?vue&type=template&id=61e185d0"
import script from "./section-three.vue?vue&type=script&lang=js"
export * from "./section-three.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__